module.exports = __webpack_public_path__ + "static/media/sunandpuddleslogo.7e732095.png";